import { render, staticRenderFns } from "./Registrator.vue?vue&type=template&id=2f05447e&scoped=true&"
import script from "./Registrator.vue?vue&type=script&lang=js&"
export * from "./Registrator.vue?vue&type=script&lang=js&"
import style0 from "./Registrator.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Registrator.vue?vue&type=style&index=1&id=2f05447e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f05447e",
  null
  
)

export default component.exports